require('./feather')

require('./boostrap-vue')
require('./vue-ant-design')
require('./vue-axios')
require('./acl/index')
require('./portal-vue')
require('./clipboard')
require('./toastification')
require('./sweet-alerts')
require('./vue-select')
require('./vee-validate')
require('./tour')
